import React from 'react';
import { Container } from '../../globalStyles';
import {
    GallerySection,
    ImageWrapper,
    GalleryImage
} from './SingleImage.elements';

function SingleImage({ data, index }) {
    //console.log("Data: ", data);
    return (
        <GallerySection>
            <ImageWrapper key={index}>
                <GalleryImage src={data.img} alt={`${data.img} ${index + 1}`} />
            </ImageWrapper>
        </GallerySection>
    );
}

export default SingleImage;
